import * as React from "react";

function SvgCar(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <g clipPath="url(#clip-car)">
        <path
          d="M12.9851 7.09212C12.9512 6.85539 12.8412 6.69068 12.7118 6.61125C11.7596 6.02508 10.5877 5.82007 9.57625 5.46842C9.15193 5.17553 7.94112 4.3161 6.8863 4.13059C6.20458 4.0106 4.75261 3.83276 3.04324 4.34054C2.26064 4.57298 1.3977 4.93139 0.542956 5.07062C0.174146 5.13068 -0.0378837 6.55262 0.00553629 7.30623C0.0228263 7.6077 0.373176 7.77514 0.568956 7.80114C0.746145 7.82415 1.23286 7.88226 1.77925 7.94687C1.81461 8.52628 2.29652 8.98323 2.88464 8.98323C3.38709 8.98323 3.81388 8.69736 3.94973 8.17736C4.48897 8.17736 7.32921 8.17736 9.39295 8.17736C9.52841 8.69736 9.95416 8.9766 10.457 8.9766C10.9588 8.9766 11.3857 8.69736 11.5214 8.17736C11.571 8.17736 11.6001 8.17736 11.6037 8.17736C11.6037 8.17736 12.1798 8.17736 12.6117 8.17736C12.8022 8.17736 12.9195 8.1134 12.9707 7.93764C12.9991 7.83949 13.0121 7.27997 12.9851 7.09212ZM2.20838 5.38067C1.9983 5.36117 2.03249 5.28785 2.12037 5.23416C2.39077 5.06893 3.7806 4.72651 4.07362 4.66788L4.21038 5.48571L2.20838 5.38067ZM8.64429 5.69319C8.3653 5.68721 4.8336 5.48558 4.8336 5.48558C4.8336 5.48558 4.7036 4.78488 4.65485 4.61887C5.27001 4.55075 6.21745 4.52111 7.04256 4.77513C7.70075 4.97767 8.13638 5.24378 8.67002 5.60531C8.71383 5.63469 8.69186 5.69319 8.64429 5.69319Z"
          fill={fill ?? "black"}
        />
      </g>
      <defs>
        <clipPath id="clip-car">
          <rect width={13} height={13} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCar;
